$(document).ready(function(){

  $('.ad-event').on('click',function(){
    var tabActive = $('.step-box__button.active').data('target');
    var tabNext = $(this).data('target');
    var button = $(this);
    button.addClass('button--loading');

    if(tabActive == 'admision-colegio')
    validate_admision_colegio(button,tabNext);

    if(tabActive == 'admision-alumno')
    validate_admision_alumno(button,tabNext);

    if(tabActive == 'admision-apoderado')
    validate_admision_apoderado(button,tabNext);

    return false;
  });


  function validate_admision_colegio(button,tabNext){
    var tab = $('.step-box__target[data-tabname=admision-colegio]');
    var formData = $('#admision-colegio').serializeArray();
    formData.push({name:'form',value: 'colegio'});

    $.ajax({ url: data.base_url + 'postulacion', method: "POST", data:$.param(formData)})
    .done(function(json) {
      json = JSON.parse(json);
      if(json.code == 422){
        for(input in json.data){
          $('#msg-form-colegio').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>'+json.data[input]+'</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
          setTimeout(function () { $('#msg-form-colegio .message').remove(); }, 4000);
        }
      }
      if(json.code == 200){
        tab.data('validate',true);
        nextTab(tabNext);
      }

      button.removeClass('button--loading');
    });
  }

  function validate_admision_alumno(button,tabNext){
    var tab = $('.step-box__target[data-tabname=admision-alumno]');
    var formData = $('#admision-alumno').serializeArray();
    formData.push({name:'form',value: 'alumno'});

    $.ajax({ url: data.base_url + 'postulacion', method: "POST", data:$.param(formData)})
    .done(function(json) {
      json = JSON.parse(json);
      if(json.code == 422){
        for(input in json.data){
          $('[name='+input+']').addClass('invalid-input').parents('.form-control').attr('data-error-message',json.data[input]).addClass('form-control--invalid');
          $('[name='+input+']').siblings('.form-control__text').hide();
          removeClass($('[name='+input+']'));
        }
      }
      if(json.code == 200){
        tab.data('validate',true);
        nextTab(tabNext);
      }

      button.removeClass('button--loading');
    });
  }

  function validate_admision_apoderado(button,tabNext){
    var tab = $('.step-box__target[data-tabname=admision-apoderado]');
    var formData = $('#admision-colegio').serializeArray();
    formData = formData.concat($('#admision-alumno').serializeArray());
    formData = formData.concat($('#admision-apoderado').serializeArray());
    formData.push({name:'form',value: 'all'});

    $.ajax({ url: data.base_url + 'postulacion', method: "POST", data:$.param(formData)})
    .done(function(json) {
      json = JSON.parse(json);
      if(json.code == 422){
        for(input in json.data){
          if($('#admision-apoderado [name='+input+']').length > 0){
            $('#admision-apoderado [name='+input+']').addClass('invalid-input').parents('.form-control').attr('data-error-message',json.data[input]).addClass('form-control--invalid');
            $('#admision-apoderado [name='+input+']').siblings('.form-control__text').hide();
            removeClass($('#admision-apoderado [name='+input+']'));
          }else{
            $('#msg-form-arancel').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>'+json.data[input]+'</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
          }
        }
      }
      if(json.code == 200){
        $('#msg-form-arancel').html('<div class="message message--ghost-success" data-module="message"> <div class="message__body"> <p>'+json.msg+'</p> </div> <button class="message__close-button" data-role="close"></button> </div> ');
        $('#admision-alumno')[0].reset();
        $('#admision-colegio')[0].reset();
        $('#admision-apoderado')[0].reset();
      }

      if(json.code == 500){
        $('#msg-form-arancel').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>'+json.msg+'</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
      }

      setTimeout(function () {
        $('#msg-form-arancel .message').remove();
      }, 4000);

      button.removeClass('button--loading');
    });
  }

  function nextTab(tabNext){
    $('.step-box__target.active').removeClass('active');
    $('.step-box__button.active').removeClass('active');

    $('.step-box__target[data-tabname='+tabNext+']').addClass('active');
    $('.step-box__button[data-target='+tabNext+']').addClass('active');
  }

  $('input[name=colegio]').on('click',function(){
    $('.colegio-apostular').html($(this).val());
  });

  function removeClass(input){
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }
});
